var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcofilterpink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "ico_filter_pink",
    "data-name": "ico filter pink",
    width: 19,
    height: 17,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAARCAYAAAA/mJfHAAABN0lEQVQ4jaXUTSvsYRgG8N8wC8lLsvEVfAFLVkpyShbECmVBYWOhbOyVpM45QjZ2KEpZ2Fixoex8jImzOXVi6NYz9W9i/jNzruX9cj3X/dwvhfLwioQBbOIV63jSIIrYQi/mMqmjOMI7WnIow/+CgyBb+yKgFQsNCvsbZFPowSr6k+MBeyjUqewZV9k/C+Mi3hJRwyhmEsr42QxJVk0zGMQ9HjFWyQ9lu+hKyvLwlnJmM3GX+BVVhWP5f0pLWIomBNkkuutUVk7qZjCSbLfYxnWQnTah5BjjqeSzirFYO6cmLqqdtbo5hBPso7Me9mLqRLabsehtmM7E/YgJT/GxFdWC/uB3OGPq89CH+ZygUpBNpG7GhQj8Qwd20J5sNzhMB6D6a0JpXI3Pbp5/89IdYnFL2MgdHXwA0m85pIHPnAIAAAAASUVORK5CYII="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcofilterpink);
export default __webpack_public_path__ + "static/media/ico filter pink.00492621.svg";
export { ForwardRef as ReactComponent };